/**
 * Resizable Cart Drawer
 * Allows users to resize the cart drawer by dragging its left edge
 */
document.addEventListener('DOMContentLoaded', function() {
  // Hide drawer sections that contain hidden elements
  function hideEmptySections() {
    // Find all trust badge elements
    const trustBadges = document.querySelectorAll('.dbtfy-trust_badge');
    
    // Check each trust badge
    trustBadges.forEach(badge => {
      // Get computed style
      const style = window.getComputedStyle(badge);
      
      // If the badge is hidden
      if (style.display === 'none' || style.visibility === 'hidden' || badge.offsetParent === null) {
        // Find the parent drawer section
        const drawerSection = badge.closest('.drawer__inner-section');
        if (drawerSection) {
          // Hide the parent section
          drawerSection.style.display = 'none';
        }
      }
    });
  }
  
  // Run initially and after cart drawer is opened/updated
  setTimeout(hideEmptySections, 500);
  
  // Re-run when cart is updated
  document.addEventListener('cart:updated', function() {
    setTimeout(hideEmptySections, 500);
  });
  
  // Re-run when drawer is opened
  document.addEventListener('drawerOpen', function() {
    setTimeout(hideEmptySections, 500);
  });
  
  // Configuration - using functions to always get current values
  const getMinDrawerWidth = () => 400; // Minimum drawer width in pixels (matches theme default)
  const getMaxDrawerWidth = () => window.innerWidth * 0.7; // Maximum drawer width (50% of viewport)
  
  // Get the cart drawer element
  const cartDrawer = document.getElementById('CartDrawer');
  
  // Create and append the resize handle
  const resizeHandle = document.createElement('div');
  resizeHandle.className = 'drawer-resize-handle';
  cartDrawer.appendChild(resizeHandle);
  
  // Drag functionality
  let isResizing = false;
  let initialX;
  let initialWidth;
  
  // Handle mouse events
  resizeHandle.addEventListener('mousedown', initDrag);
  document.addEventListener('mousemove', dragMove);
  document.addEventListener('mouseup', dragEnd);
  
  // Handle touch events for mobile
  resizeHandle.addEventListener('touchstart', initDrag);
  document.addEventListener('touchmove', dragMove);
  document.addEventListener('touchend', dragEnd);
  
  // Initialization function for drag
  function initDrag(e) {
    isResizing = true;
    initialX = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX;
    initialWidth = parseInt(window.getComputedStyle(cartDrawer).width, 10);
    
    // Add a class to indicate active dragging
    document.body.classList.add('drawer-resizing');
    
    // Prevent text selection during drag
    e.preventDefault();
  }
  
  // Function to handle drag movement
  function dragMove(e) {
    if (!isResizing) return;
    
    const currentX = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
    const deltaX = initialX - currentX;
    let newWidth = initialWidth + deltaX;
    
    // Constrain width between min and max values
    newWidth = Math.max(getMinDrawerWidth(), Math.min(newWidth, getMaxDrawerWidth()));
    
    // Apply the new width
    cartDrawer.style.width = `${newWidth}px`;
    
    // Save the width to localStorage for persistence
    localStorage.setItem('cartDrawerWidth', newWidth);
  }
  
  // Function to end dragging
  function dragEnd() {
    if (!isResizing) return;
    isResizing = false;
    document.body.classList.remove('drawer-resizing');
  }
  
  // Restore saved width on load if available
  const savedWidth = localStorage.getItem('cartDrawerWidth');
  if (savedWidth) {
    // Ensure the saved width is within current bounds
    const parsedWidth = parseInt(savedWidth, 10);
    const constrainedWidth = Math.max(getMinDrawerWidth(), Math.min(parsedWidth, getMaxDrawerWidth()));
    cartDrawer.style.width = `${constrainedWidth}px`;
  }
  
  // Update width on window resize to keep it within bounds
  window.addEventListener('resize', function() {
    // If current drawer width is outside bounds, adjust it
    const currentWidth = parseInt(window.getComputedStyle(cartDrawer).width, 10);
    const minWidth = getMinDrawerWidth();
    const maxWidth = getMaxDrawerWidth();
    
    if (currentWidth < minWidth) {
      cartDrawer.style.width = `${minWidth}px`;
      localStorage.setItem('cartDrawerWidth', minWidth);
    } else if (currentWidth > maxWidth) {
      cartDrawer.style.width = `${maxWidth}px`;
      localStorage.setItem('cartDrawerWidth', maxWidth);
    }
  });
});
